import React from 'react';
import { AddOnCard } from '@/components/ui/AddOnCard';
import { HorizontalScrollContainer } from '@/components/ui/HorizontalScrollContainer';

interface AddOnItem {
  add_on?: {
    id?: string;
    name?: string;
    image_id?: string | null;
    price?: number;
  };
  quantity?: number;
  price?: number;
}

interface TransferAddOnsDisplayProps {
  /** Array of add-ons to display */
  addons: AddOnItem[];
  /** Click handler for add-on card */
  onAddonClick?: (addon: AddOnItem) => void;
  /** Currency code (e.g., 'GBP', 'USD') for proper formatting */
  currency?: string;
}

/**
 * Horizontal scrollable add-ons display for transfer booking page.
 */
export const TransferAddOnsDisplay: React.FC<TransferAddOnsDisplayProps> = ({
  addons,
  onAddonClick,
  currency,
}) => {
  if (addons.length === 0) return null;

  return (
    <HorizontalScrollContainer title="Add-ons">
      {addons.map((addon, idx) => {
        const totalQuantity = addon.quantity || 1;
        const totalPrice = (addon.price || addon.add_on?.price || 0) * totalQuantity;

        return (
          <AddOnCard
            key={addon.add_on?.id || idx}
            imageId={addon.add_on?.image_id}
            name={addon.add_on?.name || 'Add-on'}
            price={totalPrice}
            quantity={totalQuantity}
            currency={currency}
            onClick={() => onAddonClick?.(addon)}
          />
        );
      })}
    </HorizontalScrollContainer>
  );
};

export default TransferAddOnsDisplay;
